import React from 'react'
import { Button } from '../button';
import * as Svg from "../svg";

export default function Modal({ show, onClose, icon, onClick, confirmButtonText, children, showCancelButton=true }) {
    if (!show) {
      return null;
    }
  
    return (
      <div className="modal-overlay">
        <div className="modal-content">
          { !showCancelButton && <div className="icon" onClick={onClose}><Svg.SvgClose></Svg.SvgClose></div>}
          {icon && <div className="modal-icon">{icon}</div>}
          {children}
          <div className="modal-buttons text-center">
            { showCancelButton &&
              <Button variant="outline-primary" size="sm" onClick={onClose}>{gettext('Cancel')}</Button>
            }
            <Button variant="primary" size="sm" onClick={onClick}>{confirmButtonText}</Button>
          </div>
        </div>
      </div>
    );
  }
  
  